import React from "react";

import Box from "../mui/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { styled } from "@mui/material/styles";
import { SxProps, Theme } from "@mui/material";

interface Props {
  isLoading?: boolean;
  sx?: SxProps<Theme>;
  width?: number;
  height?: number;
}

const MagicLoadingBox: React.FC<Props> = (props) => {

  const { isLoading = true , sx = {} , width, height, ...restProps } = props;
  return (
    <LoadingBoxStyle width={width} height={height} sx={{...sx}} {...restProps} >
        {isLoading && <CircularProgress />}
    </LoadingBoxStyle>
   
  );
};


const LoadingBoxStyle = styled(Box)(({ width, height }: { width?: number; height?: number }) => ({
    background: "#FFFFFF",
    border: "1px solid #CECECE",
    height: height || "100px", // Use dynamic height
    width: width || "100%",  // Use dynamic width
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    marginBottom:"24px",
}));

export default MagicLoadingBox;
